<div [hidden]="!isOpen">
  <dcp-content-loading-indicator *ngIf="!isPaymentElementLoaded"></dcp-content-loading-indicator>
  <ng-container *ngIf="elementsOptions?.clientSecret as clientSecret">
    <div id='payment-element' data-cy="stripe-payment-element"></div>
    <ng-container *ngIf="isPaymentElementLoaded">
      <div class="mt-3">
        <udex-button
          class="udex-me-4"
          size="Large"
          design="Primary"
          data-cy="stripe-save-cc-button"
          [disabled]="isSaveCardInProgress || formIncomplete"
          (click)="saveCreditCard()"
        >
          <span *ngIf="!isSaveCardInProgress; else spinner">
            {{'common.save' | cxTranslate}}
          </span>
          <ng-template #spinner>
            <ui5-busy-indicator
              size="Medium"
              class="white-dots d-flex"
              active></ui5-busy-indicator>
          </ng-template>
        </udex-button>
        <udex-button
          *ngIf="isClosable"
          size="Large"
          design="Secondary"
          data-cy="stripe-close-btn"
          [disabled]="isSaveCardInProgress"
          (click)="close()">{{'common.cancel' | cxTranslate}}
        </udex-button>
      </div>
      <div class="card-errors mt-2" *ngIf="errorMessage">
        {{errorMessage}}
      </div>
      <hr>
    </ng-container>
  </ng-container>
</div>
